import React, { CSSProperties } from "react";
import cx from "classnames";
import styles from "./section.module.scss";

export interface ISection {
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const Section = (props: ISection) => {
  return (
    <div className={cx(styles.section, props.className)} style={props.style} id={props.htmlId}>
      {props.children}
    </div>
  );
};

Section.defaultProps = {};
